// Realtime events for "Talk now". LiveNotificationHandler re-broadcasts the
// practice-channel messages as window CustomEvents (like voice.call and
// virtual_consultation.presence) so the host component needs no second socket.
export const INSTANT_VIDEO_RINGING = 'instant_video.ringing';
export const INSTANT_VIDEO_TAKEN = 'instant_video.taken';
export const INSTANT_VIDEO_ENDED = 'instant_video.ended';
export const INSTANT_VIDEO_WINDOW_EVENT = 'instant-video-event';

// Accepts the raw frame (string/object, optionally wrapped as { type, data }) and
// returns { type, request_id, first_name?, expires_at?, seconds? } or null. `taken` and
// `ended` (missed / cancelled) both mean the card goes away.
export const parseInstantVideoPayload = (data) => {
    let payload = data;
    if (typeof data === 'string') {
        try { payload = JSON.parse(data); } catch { return null; }
    }
    if (!payload || typeof payload !== 'object') return null;
    const type = payload.type || payload.event;
    if (![INSTANT_VIDEO_RINGING, INSTANT_VIDEO_TAKEN, INSTANT_VIDEO_ENDED].includes(type)) return null;
    const body = payload.data && typeof payload.data === 'object' ? { ...payload, ...payload.data } : payload;
    if (body.request_id == null) return null;
    const text = (value) => (typeof value === 'string' && value.trim() ? value.trim().slice(0, 80) : undefined);
    return {
        type,
        request_id: String(body.request_id),
        first_name: text(body.first_name),
        expires_at: Number.isNaN(Date.parse(body.expires_at)) ? undefined : body.expires_at,
        seconds: Number.isFinite(body.seconds) && body.seconds > 0 && body.seconds <= 300 ? body.seconds : undefined,
    };
};
